import React, { FC } from 'react';
import { graphql } from 'gatsby';

import LegalPage, { ILegalPageProps } from 'components/LegalPage';

/* eslint-disable react/no-danger */
const PrivacyPolicyPage: FC<ILegalPageProps> = ({
  data,
}) => (
  <LegalPage data={data} />
);
/* eslint-enable react/no-danger */

export const query = graphql`
  query PrivacyPolicyPageQuery {
    legalPageData: allContentfulLegalPage(
      filter: { slug: {eq: "privacy-policy" } }
    ) {
      nodes {
        slug
        title
        body {
          raw
          references {
            ... on ContentfulLegalPageAnchor {
              contentful_id
              __typename
              anchor
            }
          }
        }
      }
    }
  }
`;

export default PrivacyPolicyPage;
